



















import Vue, { PropOptions } from 'vue';

export type FeatureDetail = Blok & {
  title: string;
  description: string;
  markedText: string;
  markedTextColor: string;
  media: Blok[];
  mediaFirst: boolean;
  mediaDown: boolean;
  titleMaxWidth: number;
  descriptionMaxWidth: number;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<FeatureDetail>,
  },
  computed: {
    hasMedia(): boolean {
      return !!this.blok?.media?.length;
    },
    hasMarkedText(): boolean {
      return !!this.blok?.markedText?.length;
    },
    cssVars(): CSSVars {
      return {
        '--desktop-columns': this.blok?.mediaDown
          ? 'repeat(1, 1fr)'
          : 'repeat(2, 1fr)',
        '--title-max-width': this.blok.titleMaxWidth
          ? `${this.blok.titleMaxWidth}ch`
          : '100%',
        '--description-max-width': this.blok.descriptionMaxWidth
          ? `${this.blok.descriptionMaxWidth}ch`
          : '100%',
      };
    },
  },
});
